<template>
  <div>
    <div
      v-if="
        test.is_valid == true &&
        test.manual_is_valid == false &&
        test.evaluative_agent != null &&
        test.evaluation_situation != null
      "
    >
      <b-button
        size="sm"
        class="mb-2"
        @click="ManualIsValidInTest()"
        :disabled="disabled_button"
        >{{ $t("reusable.common.close") }}
        {{ $getVisibleNames("evaluations2.test", false, "Instrumentos") }}
      </b-button>
    </div>
    <b-table-simple bordered>
      <b-thead>
        <b-tr>
          <b-th class="text-center" style="width: 45%">{{
            $t("matterProgram.matterProgramView.criteria")
          }}</b-th>
          <b-th class="text-center" style="width: 10%">{{
            $t("matterProgram.matterProgramView.complies")
          }}</b-th>
          <b-th class="text-center">{{
            $t("matterProgram.matterProgramView.problems")
          }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <!-- Template para cuando has_rubric es false y los demas campos tienen datos false y arrays -->
        <template v-if="test.is_valid[1] && test.is_valid[1].has_rubric">
          <b-tr v-for="(value, key) in filteredTestIsValid" :key="key">
            <b-td>{{ nameErrorTest(key) }}</b-td>
            <b-td class="align-middle">
              <div class="text-center">
                <b-badge
                  v-if="
                    (!Array.isArray(value) && !value) ||
                    (Array.isArray(value) && value.length > 0)
                  "
                  variant="danger"
                  class="p-2 badge-test"
                >
                  {{ $t("reusable.common.no") }}
                </b-badge>
                <b-badge
                  v-if="
                    (Array.isArray(value) && value.length == 0) || value == true
                  "
                  variant="success"
                  class="p-2 badge-test"
                >
                  {{ $t("reusable.common.yes") }}
                </b-badge>
              </div>
            </b-td>
            <b-td class="td-inconsistencia p-0 align-middle">
              <div v-if="!Array.isArray(value) && !value" class="mx-2">
                <div
                  v-if="
                    !Array.isArray(value) &&
                    key == 'test_evaluation_criteria_micro_weighing_sum_is_100'
                  "
                >
                  {{
                    $t("matterProgram.matterProgramView.reviewWeighingsOf1", {
                      entity: $getVisibleNames(
                        "teaching.evaluationcriteriamicro",
                        true,
                        "Criterio de Evaluación Micro"
                      ),
                    })
                  }}
                </div>
                <div
                  v-if="
                    !Array.isArray(value) &&
                    key == 'rubric_criteria_weighing_sum_is_100'
                  "
                >
                  {{
                    $t("matterProgram.matterProgramView.reviewWeighingsOf2", {
                      entity: $getVisibleNames(
                        "manual.dimension",
                        true,
                        "Dimensión"
                      ),
                    })
                  }}.
                </div>
              </div>
              <div v-if="Array.isArray(value)" class="text-justify">
                <div v-for="detail in value" :key="detail">
                  <div
                    v-if="key == 'rubric_criteria_weighing_0'"
                    class="p-0 mx-2 height-criteria"
                  >
                    <BoundedTextContainer
                      :Text="getRubricCriterias(detail)"
                      :tooltip_text="getRubricCriterias(detail)"
                      :single_line="true"
                    ></BoundedTextContainer>
                  </div>
                  <div
                    v-else-if="
                      key ==
                      'rubric_criteria_weighing_sum_does_not_match_test_evaluation_criteria_micro'
                    "
                    class="p-0 mx-2 height-criteria"
                  >
                    <BoundedTextContainer
                      :Text="getRubricCriteriasMicro(detail)"
                      :tooltip_text="getRubricCriteriasMicro(detail)"
                      :single_line="true"
                    ></BoundedTextContainer>
                  </div>
                </div>
              </div>
            </b-td>
          </b-tr>
        </template>
        <!-- Template para cuando has_rubric es true y los demas campos son null -->
        <template v-if="test.is_valid[1] && !test.is_valid[1].has_rubric">
          <b-td>
            {{ $getVisibleNames("evaluations2.rubric", false, "Pauta") }}
            {{ $t("matterProgram.matterProgramView.existing") }}.
          </b-td>
          <b-td>
            <div class="text-center">
              <b-badge variant="danger" class="p-2">
                {{ $t("reusable.common.no") }}
              </b-badge>
            </div>
          </b-td>
          <b-td>
            {{
              $t("matterProgram.matterProgramView.mustCreateA", {
                entity: $getVisibleNames("evaluations2.rubric", false, "Pauta"),
              })
            }}.
          </b-td>
        </template>
        <!-- template para mostrar que no existe Situacion Evaluativa -->
        <template
          v-if="
            test.evaluative_agent == null || test.evaluation_situation == null
          "
        >
          <tr>
            <b-td>
              {{
                $t("matterProgram.matterProgramView.hasFieldSelected", {
                  entity: $getVisibleNames(
                    "teaching.evaluationsituation",
                    false,
                    "Situación Evaluativa"
                  ),
                })
              }}.
            </b-td>
            <b-td>
              <div class="text-center">
                <b-badge variant="danger" class="p-2">
                  {{ $t("reusable.common.no") }}
                </b-badge>
                <b-badge
                  v-if="test.evaluation_situation != null"
                  variant="success"
                  class="p-2 badge-test"
                >
                  {{ $t("reusable.common.yes") }}
                </b-badge>
              </div>
            </b-td>
            <b-td>
              {{
                $t("matterProgram.matterProgramView.mustSelectInForm", {
                  article: "una",
                  entity: $getVisibleNames(
                    "teaching.evaluationsituation",
                    false,
                    "Situación Evaluativa"
                  ),
                })
              }}.
            </b-td>
          </tr>
        </template>
        <!-- template para mostrar que no existe Agente Evaluativo -->
        <template v-if="test.evaluative_agent == null">
          <tr>
            <b-td>
              {{
                $t("matterProgram.matterProgramView.hasFieldSelected", {
                  entity: $getVisibleNames(
                    "teaching.evaluativeagent",
                    false,
                    "Agente Evaluativo"
                  ),
                })
              }}.
            </b-td>
            <b-td>
              <div class="text-center">
                <b-badge variant="danger" class="p-2">
                  {{ $t("reusable.common.no") }}
                </b-badge>
                <b-badge
                  v-if="test.evaluative_agent != null"
                  variant="success"
                  class="p-2 badge-test"
                >
                  {{ $t("reusable.common.yes") }}
                </b-badge>
              </div>
            </b-td>
            <b-td>
              {{
                $t("matterProgram.matterProgramView.mustSelectInForm", {
                  article: "un",
                  entity: $getVisibleNames(
                    "teaching.evaluativeagent",
                    false,
                    "Agente Evaluativo"
                  ),
                })
              }}.
            </b-td>
          </tr>
        </template>

        <!-- Mensaje para cuando no existen inconsistencias -->
        <template
          v-if="
            test.is_valid === true &&
            test.evaluative_agent != null &&
            test.evaluation_situation != null
          "
        >
          <b-tr>
            <b-td class="text-center" colspan="3"
              >{{
                $t("matterProgram.matterProgramView.noInconsistencies")
              }}.</b-td
            >
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "InfoTestTable",
  components: {
    BoundedTextContainer: () =>
      import("@/components/reusable/BoundedTextContainer"),
  },
  props: {
    test: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      disabled_button: false,
    };
  },
  computed: {
    ...mapGetters({
      rubricInstances: names.NEW_RUBRIC_CRITERIAS,
      evaluation_criteria_micros: names.EVALUATION_CRITERIAS,
    }),
    filteredTestIsValid() {
      const testIsValid = this.test.is_valid[1];
      const filteredTestIsValid = {};
      Object.keys(testIsValid).forEach((x) => {
        if (x != "has_rubric") {
          filteredTestIsValid[x] = testIsValid[x];
        }
      });
      return filteredTestIsValid;
    },
    error_message() {
      return [
        {
          key: "has_rubric",
          name: `${this.$t("matterProgram.matterProgramView.exists", {
            entity: this.$getVisibleNames(
              "evaluations2.rubric",
              false,
              "Pauta"
            ),
          })}.`,
        },
        {
          key: "test_evaluation_criteria_micro_weighing_sum_is_100",
          name: `${this.$t(
            "matterProgram.matterProgramView.weighingOfEntitySums100",
            {
              gender: "los",
              entity: this.$getVisibleNames(
                "teaching.evaluationcriteriamicro",
                true,
                "Criterio de Evaluación Micro"
              ),
            }
          )}.`,
        },
        {
          key: "rubric_criteria_weighing_sum_is_100",
          name: `${this.$t(
            "matterProgram.matterProgramView.weighingOfEntitySums100",
            {
              gender: "los",
              entity: this.$getVisibleNames(
                "manual.dimension",
                false,
                "Dimensión"
              ),
            }
          )}.`,
        },
        {
          key: "rubric_criteria_weighing_0",
          name: `${this.$t(
            "matterProgram.matterProgramView.allEntitiesContributeTo",
            {
              gender: "las",
              entity1: this.$getVisibleNames(
                "manual.dimension",
                true,
                "Dimensión",
                true
              ),
              gender2: "",
              entity2: this.$getVisibleNames(
                "evaluations2.test",
                false,
                "Instrumento",
                true
              ),
            }
          )}. `,
        },
        {
          key: "rubric_criteria_weighing_sum_does_not_match_test_evaluation_criteria_micro",
          name: `${this.$t(
            "matterProgram.matterProgramView.sumOfWeighingsDoesNotMatch",
            {
              gender: "las",
              entity1: this.$getVisibleNames(
                "manual.dimension",
                true,
                "Dimensión",
                true
              ),
              gender2: "los",
              entity2: this.$getVisibleNames(
                "teaching.evaluationcriteriamicro",
                true,
                "Criterio de Evaluación Micro",
                true
              ),
            }
          )}.`,
        },
      ];
    },
  },
  methods: {
    getRubricCriterias(criteria) {
      const rubric_criteria = this.rubricInstances.find(
        (x) => x.id == criteria
      );
      if (rubric_criteria) return rubric_criteria.full_sentence;
      else return "";
    },
    getRubricCriteriasMicro(criteria) {
      const criteria_micro = this.evaluation_criteria_micros.find(
        (x) => x.id == criteria
      );
      if (criteria_micro) return criteria_micro.full_sentence;
      else return "";
    },
    nameErrorTest(key) {
      const errorMessage = this.error_message.find((x) => x.key == key);
      return errorMessage ? errorMessage.name : "";
    },
    ManualIsValidInTest() {
      this.disabled_button = true;
      this.$store
        .dispatch(names.PATCH_NEW_TEST, {
          new_test_id: this.test.id,
          item: { manual_is_valid: true },
        })
        .then(() => {
          this.disabled_button = false;
        });
    },
  },
  created() {},
};
</script>

<style scoped>
th {
  background-color: var(--kl-menu-color) !important;
  color: white;
}
.badge-test {
  width: 32px;
  height: 29px;
}
.td-inconsistencia {
  max-width: 150px;
}
.height-criteria {
  align-content: center;
}
</style>

